import React from "react";

export default function Dot({ children }: { children: React.ReactNode }): React.JSX.Element {
	return (
		<>
			&nbsp;&nbsp;&nbsp;&nbsp;●&nbsp;&nbsp;{children}
			<br />
		</>
	);
}
